import { render, staticRenderFns } from "./supervisionDetail.vue?vue&type=template&id=05ffbb42&scoped=true"
import script from "./supervisionDetail.vue?vue&type=script&lang=js"
export * from "./supervisionDetail.vue?vue&type=script&lang=js"
import style0 from "./supervisionDetail.vue?vue&type=style&index=0&id=05ffbb42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ffbb42",
  null
  
)

export default component.exports